import React from 'react';

import theme from 'theme';

// components
import AampeAccordion from 'components/shared/AampeAccordion/AampeAccordion';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// constants
import { ActivtyLog } from 'models/activty-log.model';

import AuditTrailContent from './AuditTrailContent';

type AuditTrailViewProps = {
    sortedDates: string[];
    groupedLogs: Record<string, ActivtyLog[]>;
};

const AuditTrailView: React.FC<React.PropsWithChildren<AuditTrailViewProps>> =
    ({ sortedDates, groupedLogs }) => {
        return (
            <Container>
                {sortedDates.map((date) => (
                    <StyledAampeAccordion
                        title={date}
                        defaultExpanded={sortedDates[0] === date}
                        key={date}
                    >
                        <AuditTrailContent
                            data={groupedLogs[date]}
                            date={date}
                        />
                    </StyledAampeAccordion>
                ))}
            </Container>
        );
    };

const Container = styled.div(() => ({
    display: 'flex',
    borderRadius: aampeTheme.borderRadius.default,
    gap: aampeTheme.spacing4(9),
    flexDirection: 'column',
    minHeight: '500px',
}));

const StyledAampeAccordion = styled(AampeAccordion)(() => ({
    boxShadow: 'none !important',
    border: 'none !important',
    '&.MuiAccordion-root:before': {
        height: 0,
    },
    '.MuiAccordionSummary-root': {
        padding: 0,
        minHeight: 0,
    },
    '.MuiIconButton-root': {
        padding: 0,
    },
    '.MuiAccordionSummary-content': {
        fontSize: aampeTheme.size.font.textMedium,
        fontWeight: 600,
        color: aampeTheme.colors.textAccessibleWG01,
        margin: 0,
        fontFamily: theme.typography.fontFamily,
    },
    '.MuiAccordionDetails-root': {
        padding: 0,
        marginTop: aampeTheme.spacing4(5),
    },
    '.MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 0,
        gap: aampeTheme.spacing4(5),
    },
    '&.MuiAccordion-root.Mui-expanded': {
        margin: 0,
    },
    '.MuiAccordionSummary-content.Mui-expanded': {
        margin: 0,
    },
}));
export default AuditTrailView;
